import Paper from '@material-ui/core/Paper';
import { styled } from '@material-ui/core/styles';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';

export const Container = styled(Paper)({
  width: '100%',
  overflow: 'hidden'
});

export const TopHeaderCell = styled(TableCell)(({ theme }) => ({
  backgroundColor: theme.palette.grey[400],
  color: theme.palette.text.primary,
  textAlign: 'center',
  whiteSpace: 'nowrap'
}));

export const DarkHeaderCell = styled(TableCell)(({ theme }) => ({
  backgroundColor: theme.palette.grey[700],
  color: theme.palette.common.white,
  textAlign: 'center',
  whiteSpace: 'nowrap',
  '&:first-of-type': {
    textAlign: 'left'
  }
}));

export const BodyRow = styled(TableRow)(() => ({
  '&:last-child td, &:last-child th': { border: 0 }
}));

export const BodyHeaderCell = styled(TableCell)(({ theme }) => ({
  color: theme.palette.grey[700],
  textAlign: 'center',
  '&:first-of-type': {
    textAlign: 'left'
  }
}));

export const BodyCell = styled(TableCell)(({ theme }) => ({
  color: theme.palette.grey[700],
  textAlign: 'center'
}));
